export default "assets/images/icons/youtube-355e58e5.svg";